<sh-droppanel
    [inOverflownContainer]="inOverflownContainer"
    [height]="height"
    [openDirection]="openDirection"
    [droppanelStyle]="droppanelStyle"
    [isOpen$]="isOpen$"
    [hasOptions$]="hasOptions$"
    [limitHeightToViewport$]="limitHeightToViewport$"
    [loading$]="loading$"
    [focusMode]="focusIndex >= 0"
>
    <div droppanelToggle #toggleContainer (keyup)="handleDeletePress($event)">
        <ng-content></ng-content>
    </div>

    <div *ngIf="search && !autocomplete" class="sh-droppanel__search" header>
        <div class="sh-input-field-with-icon">
            <input
                #searchInput
                type="search"
                autocomplete="off"
                [id]="id + '-search-input'"
                [formControl]="searchControl"
                [placeholder]="searchPlaceholderMsg"
                class="sh-input-field sh-input-field-with-icon__input sh-droppanel__search__input"
                (focus)="onSearchFocus()"
                (mouseenter)="onHoverSearch()"
            />
            <svg sh-icon class="sh-input-field-with-icon__icon" [name]="'search'" [size]="sizes.SMALL" aria-hidden="true"></svg>
        </div>
    </div>

    <div *ngIf="autocomplete" class="sh-droppanel__search" header>
        <div class="sh-input-field-with-icon">
            <sh-autocomplete
                style="width: 100%"
                [autocompleteFct]="autocompleteFct"
                [clearMarginModifiers]="clearMarginModifiers"
                [multiple]="multiple"
                [selectedValues]="selectedValues$ | async"
                (initialAutocompleteOptions)="receiveInitialAutocompleteOptions($event)"
                (suggestionsSelected)="receiveSelectedSuggestion($event)"
            >
                <input
                    type="text"
                    autocomplete="off"
                    [id]="id + '-autocomplete-input'"
                    [formControl]="autocompleteInputControl"
                    [placeholder]="searchPlaceholderMsg"
                    (mouseenter)="onHoverSearch()"
                    class="sh-input-field sh-input-field-with-icon__input sh-droppanel__search__input"
                />
            </sh-autocomplete>
            <svg sh-icon class="sh-input-field-with-icon__icon" [name]="'search'" [size]="sizes.SMALL" aria-hidden="true"></svg>
        </div>
    </div>

    <ng-container *ngIf="!(loading$ | async); else loading">
        <ng-container *ngIf="cappedFilteredOptions$ | async as cappedFilteredOptions">
            <ul #optionContainer shChildIndex class="sh-droppanel__list" [id]="id + '-list'">
                <ng-container *ngIf="!autocompleteInputControl.value">
                    <ng-container
                        *ngFor="let option of cappedFilteredOptions; let index = index; trackBy: trackByFn"
                        [ngTemplateOutlet]="multiple ? checkbox : noCheckbox"
                        [ngTemplateOutletContext]="{ option: option, index: index }"
                    ></ng-container>
                    <sh-action-item
                        [ngStyle]="{ display: listCappedMsg && (showExtraItemsLabelIndicator$ | async) ? 'block' : 'none' }"
                        class="sh-droppanel__list__item sh-droppanel__list-action"
                        [bubbleEvent]="false"
                        [item]="loadMoreActionItem"
                        [disableArrowNavigation]="true"
                        (mouseenter)="onHover($event)"
                    ></sh-action-item>
                </ng-container>
                <ng-container *ngIf="!(loading$ | async) && cappedFilteredOptions.length === 0">
                    <sh-action-item
                        *ngIf="noResultsActionItem; else noResultsFoundTextMsg"
                        class="sh-droppanel__list__item sh-droppanel__list-action sh-no-results-action"
                        [item]="noResultsActionItem"
                        (keyup.enter)="setDropdownClosed()"
                        (click)="setDropdownClosed()"
                        [disableArrowNavigation]="true"
                        (mouseenter)="onHover($event)"
                    ></sh-action-item>
                    <ng-template #noResultsFoundTextMsg>
                        <li class="sh-droppanel__list__item sh-droppanel__list-action sh-no-pointer-events">
                            <i>{{ noResultsFoundMsg }}</i>
                        </li>
                    </ng-template>
                </ng-container>
            </ul>
        </ng-container>
    </ng-container>
</sh-droppanel>

<ng-template #loading>
    <ul class="sh-droppanel__list" [id]="id + '-list'">
        <li class="sh-droppanel__list__item sh-droppanel__list-action sh-no-pointer-events">
            <i>{{ loadingMsg }}</i>
        </li>
    </ul>
</ng-template>

<ng-template #checkbox let-option="option" let-index="index">
    <li
        class="sh-droppanel__list__item"
        [class.sh-visually-hidden]="loading$ | async"
        [title]="option.disabled && option.disabledInfoMsg ? option.disabledInfoMsg : ''"
    >
        <label
            tabindex="-1"
            class="sh-droppanel__list-action"
            [for]="id + '-option-' + index"
            *ngIf="{ state: getState(option) } as el"
            [class.-sh-disabled]="isDisabled(option, el.state)"
            (keydown.enter)="toggleCheckbox($event, option)"
            (keyup.space)="toggleCheckbox($event, option)"
            (mouseenter)="onHover($event)"
        >
            <input
                type="checkbox"
                tabindex="-1"
                [id]="id + '-option-' + index"
                class="sh-checkbox sh-droppanel__list-action__checkbox"
                [checked]="el.state === states.SET"
                [shIndeterminate]="el.state === states.INDETERMINATE"
                [class.-sh-disabled]="isDisabled(option, el.state)"
                [disabled]="isDisabled(option, el.state)"
                (change)="toggleCheckbox($event, option)"
            />
            <span class="sh-droppanel__list-action__label">
                <ng-container [ngSwitch]="el.state">
                    <ng-container *ngSwitchCase="states.INDETERMINATE">
                        <i style="padding-right: 0.5rem">{{ option.label }}</i>
                    </ng-container>
                    <ng-container *ngSwitchCase="states.SET">
                        <b>{{ option.label }}</b>
                    </ng-container>
                    <ng-container *ngSwitchDefault>{{ option.label }}</ng-container>
                </ng-container>
            </span>
        </label>
    </li>
</ng-template>

<ng-template #noCheckbox let-option="option">
    <li
        *ngIf="{ state: getState(option) } as el"
        tabindex="-1"
        class="sh-droppanel__list__item sh-droppanel__list-action"
        [class.sh-visually-hidden]="loading$ | async"
        [class.-sh-disabled]="option.disabled"
        [title]="option.disabled && option.disabledInfoMsg ? option.disabledInfoMsg : option.label"
        (click)="selectSingleValue(option)"
        (keydown.enter)="selectSingleValue(option)"
        (mouseenter)="onHover($event)"
    >
        <span class="sh-droppanel__list-action__label">
            <ng-container *ngIf="el.state === states.SET">
                <b>{{ option.label }}</b>
            </ng-container>
            <ng-container *ngIf="el.state === states.INDETERMINATE">
                <i style="padding-right: 0.5rem">{{ option.label }}</i>
            </ng-container>
            <ng-container *ngIf="el.state === states.UNSET">{{ option.label }}</ng-container>
        </span>
    </li>
</ng-template>
